import { createIcon } from '../icon'
import TrashIcon from '@/components/atoms/svg/TrashIcon'

export const TrashIconDefault = createIcon(TrashIcon)
